module.exports = __webpack_public_path__ + "img/Invasion-PRCA_10X_ANS.5116ba1a.png";